export class MainHeaderlabel_EN {

    mainHeader: {
        title: string;
        welcomeText: string;
        customerCare : string;
    }

    menu: {
        home: string;
        about: string;
        howItWorks: string;
        logout: string;
        faq: string;
    }

    about: {
        title: string;
        closeBtn: string;
        hindi: string;
        english: string;
    }

    constructor() {

        this.mainHeader = {
            title: "Smart Finance Platform",
            welcomeText: "Welcome",
            customerCare :"1-800-209-3456"

        }

        this.menu = {
            home: "Home",
            about: "About",
            howItWorks: "How it works",
            logout: "Logout",
            faq: "FAQ"
        }

        this.about = {
            title: "About",
            closeBtn: "Close",
            hindi: "हिंदी",
            english: "ENGLISH"
        }
    }
}